import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "default-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftAside = _resolveComponent("LeftAside")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_MainContainer = _resolveComponent("MainContainer")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftAside),
    _createVNode(_component_NavHeader),
    _createVNode(_component_MainContainer, null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _: 3
    }),
    _createVNode(_component_Footer)
  ]))
}